/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cap_2_DescInputs */

const en_mk_cap_2_desc = /** @type {(inputs: Mk_Cap_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Break big work into stages; finishing one stage can start the agent on the next.`)
};

const id_mk_cap_2_desc = /** @type {(inputs: Mk_Cap_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pekerjaan besar dipecah jadi tahap; tahap berikutnya bisa memicu agen begitu tahap sebelumnya selesai.`)
};

/**
* | output |
* | --- |
* | "Break big work into stages; finishing one stage can start the agent on the next." |
*
* @param {Mk_Cap_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cap_2_desc = /** @type {((inputs?: Mk_Cap_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cap_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cap_2_desc(inputs)
	return en_mk_cap_2_desc(inputs)
});